import { axiosInstance } from "./config.js";

export const apiServices = {
  post: async (endpoint, body,headers) => {
    try {
      const response = await axiosInstance.post(`${endpoint}`, {
        ...body,
      },{headers});

      const { data } = response;
      return data;
    } catch (e) {
      if (e.response && e.response.data) {
        throw new Error(e.response.data.message || 'API request failed');
      }
      throw e;
    }
  },
  get: async (endpoint) => {
    try {
      const response = await axiosInstance.get(`${endpoint}`);
      const { data } = response;
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'API request failed');
      }
      throw error;
    }
  },
  delete: async (endpoint, body) => {
    try {
      const response = await axiosInstance.delete(endpoint, {
        data: body,
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const { data } = response;
      return data;
    } catch (error) {
      
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || `Delete request to ${endpoint} failed`);
      }
      throw new Error(`Delete request to ${endpoint} failed: ${error.message}`);
    }
  },
  update: async (endpoint, body) => {
    try {
      const response = await axiosInstance.put(endpoint, {
        ...body,
      });
      const { data } = response;
      return data;
    } catch (error) {
     
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'API request failed');
      }
      throw error;
    }
  },
};